<template>
  <div class="faq-list">
    <template v-if="faqs.length > 0">
      <b-card v-for="(faq, index) in faqs" :key="faq.id">
        <div class="faq__content">
          <h5 v-b-toggle="'faq-' + faq.id">{{ faq.title }}</h5>
          <b-collapse :id="'faq-' + faq.id" :visible="index === 0">
            <p>{{ faq.text }}</p>
          </b-collapse>
        </div>
        <div
          v-b-toggle="'faq-' + faq.id"
          class="faq__icon d-flex justify-content-center align-items-center"
        >
          <b-img :src="require('@/assets/icons/arrow-right.svg')"></b-img>
        </div>
      </b-card>
    </template>
    <template v-else>
      <b-row class="text-center">
        <b-col
          ><p>
            {{ label }}
          </p></b-col
        >
      </b-row>
    </template>

    <custom-pagination
      :meta="faqsMeta"
      :loading="loading"
      class="faq-pagination"
      @change="setPage"
    ></custom-pagination>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * FAQ list
 * ==================================================================================
 **/

import { mapState, mapActions, mapMutations } from 'vuex'
import CustomPagination from '@/components/inputs/CustomPagination'

export default {
  components: {
    CustomPagination
  },

  props: {
    limit: {
      type: Number,
      default: 5
    }
  },

  data() {
    return {
      loading: false,
      error: null
    }
  },

  computed: {
    ...mapState({
      faqs: state => state.faq.list,
      faqsMeta: state => state.faq.listMeta
    }),

    label() {
      if (this.loading) return 'Fetching FAQs right now...'
      return this.error ? this.error : ''
    }
  },

  methods: {
    ...mapActions({
      getFaqs: 'faq/getFaqs'
    }),

    ...mapMutations({
      clearFaqs: 'faq/clearFaqList'
    }),

    async fetchFaqs(page = 1) {
      if (this.loading) return

      this.clearFaqs()
      this.loading = true
      this.error = null

      let params = {
        page: page,
        limit: this.limit
      }

      await this.getFaqs(params)
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.error = `Can't seem to fetch the FAQs, please try later or refresh the page`
        })
    },

    setPage(page) {
      this.fetchFaqs(page)
    }
  },

  created() {
    this.clearFaqs()
    this.fetchFaqs()
  }
}
</script>
<style scoped lang="scss">
.faq-list {
  .card {
    margin-bottom: 20px;
    border-radius: 1.125rem;

    &-body {
      display: flex;
      flex-direction: row;
      padding: 1.5rem;
    }
  }

  .faq__content {
    flex-grow: 1;

    > h5 {
      font-weight: 600;
      margin: 0;
      outline: none;
      user-select: none;
    }

    p {
      font-size: 0.95rem;
      line-height: 1.25rem;
      margin-top: 1.25rem;
      white-space: pre-wrap;
      color: #6c6c6c;
    }
  }

  .faq__icon {
    width: 30px;
    outline: none;

    > img {
      width: 22.5px;
      margin-left: 20px;
      transition: transform 0.3s ease;
      transform: rotate(90deg);
    }
  }

  .faq__icon[aria-expanded='true'] {
    > img {
      transform: rotate(270deg);
    }
  }

  .faq-pagination {
    margin-top: 40px;
  }
}
</style>
